// extracted by mini-css-extract-plugin
export default {"confirmModal":"VideoTextTalkModal_confirmModal__fGrk3"};